/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import * as _ from "underscore";
import { Link } from 'react-router-dom';
import SocialButton from 'app/components/common/SocialButton.jsx';
import { Breakpoint } from 'react-socks';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class OnboardingSocials extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            duplicateError: false,
            socialErrors: null,
            isDeleting: 0,
            isSocialDeleted: false,
            isConnecting: 0,
            batchComplete: false,
            showTwitterWarning: false
        };

        this.twitterRef = React.createRef();

        this._permErrorTest = this._permErrorTest.bind(this);

    }

    componentDidMount() {
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

        if (onboarding) {
            mixpanel.track("Social Onboarding - Start");

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Social Onboarding Begin',
                });
            }
        }

		if (this.props.router.query !== null && this.props.router.query.state) {
            let parts = this.props.router.query.state.split("_");
            this.setState({
                isConnecting: parseInt(parts[1])
            });
			this.props.authReturnHandler({
				    path: '/share/getstarted'
                },
                () => {
                    this.props.getSocials();
                });
        } else {
            this.props.getSocials();
        }

    }

    componentDidUpdate(prevProps, prevState) {

        let errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'SOCIAL_DELETE']),
            reportSocialCreate = () => {
                let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
                    newSocial = _.difference(this.props.socials.list, prevProps.socials.list),
                    socialName = '';

                if (newSocial.length) {
                    socialName = ConstantMixin.getPostServiceNameByCode(newSocial[0].psID);
                    if (onboarding) {
                        mixpanel.track("Social Onboarding - Connected Social", {
                            'social': socialName
                        });

                        if (this.props.recordEvent) {
                            this.props.recordEvent({
                                pub_id: this.props.user.detail.id,
                                event_name: 'Social Onboarding - Connected Social',
                                event_data: {
                                    social: socialName
                                }
                            });
                        }
                    }
                }
            };

		if (errors.length) {
			if (this._permErrorTest(errors)) {
				if (this.props.isDuplicateSocial() && this.state.duplicateError === false) {
                    let social = null;

                    if (this.state.socialId) {
    					social = _.clone(this.props.findSocial(this.state.socialId));
    				} else {
    					// the post for the last action is in the error. for the time being
    					// just dig it out of the errors
    					for (let i = 0; i < this.props.app.errors.api.length; ++i) {
    						if (this.props.app.errors.api[i].type === 'SOCIAL_CREATE') {
    							social = this.props.app.errors.api[i].post;
    						}
    					}
    				}

                    if (social) {
    					this.props.showDuplicateSocialModal(social, {
                            confirm: () => {
                                // delete now because we need to get the post info on the last request
                				this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
                				this.props.closeAllModals();

                                this.setState({
                                    duplicateError: false
                                });
                            },
                            cancel: () => {
                                // delete now because we may have needed the post info on the last request
                				this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
                				this.props.closeAllModals();

                                this.setState({
                                    duplicateError: false,
                                    isConnecting: 0
                                });
                            }
                        });
                    }

                    this.setState({
                        duplicateError: true
                    });
				}
				else if (this.state.duplicateError === false && this.state.socialErrors !== null) {
					this.props.showUpgradeModal(() => {
						this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
						this.props.closeAllModals();
					}, null, errors, 'onboarding_error');
				}
			}
			for (let i = 0; i < errors.length; ++i) {
				if (errors[i].errors[this.state.socialId]) {
					this.setState({
						socialErrors: errors[i].errors
					});
					break;
				} else if (this.props.isBlacklisted() && this.state.duplicateError === false) {
                    let callback = () => {
                        this.setState({
                            duplicateError: false
                        });
                        this.props.deleteApiError(['SOCIAL_CREATE']);
                        this.props.closeAllModals();
                    };

                    this.props.showBlacklistModal({
                        confirm: callback,
                        cancel: callback
                    });

    				this.props.deleteApiError(['SOCIAL_CREATE']);
                    this.setState({
                        duplicateError: true,
                        isConnecting: 0
                    });
                }
			}
		} else {
            if (Object.keys(prevProps.socials.batchCreates).length > 0 && Object.keys(this.props.socials.batchCreates).length === 0) {
                this.setState({
                    batchComplete: true
                });
            }

            if (prevProps.app.loading.SOCIAL_CREATE === true && this.props.app.loading.SOCIAL_CREATE === false) {
                reportSocialCreate();

                this.setState({
                    isConnecting: 0
                });
                this.props.getUserPerms();
            }

            if (this.state.batchComplete && prevProps.app.loading.SOCIAL_LIST === true && this.props.app.loading.SOCIAL_LIST === false) {
                reportSocialCreate();
                this.setState({
                    batchComplete: false
                });
                this.props.getUserPerms();
            }
        }

        if (prevProps.app.loading.SOCIAL_DELETE === true && this.props.app.loading.SOCIAL_DELETE === false) {
            this.setState({
                isSocialDeleted: true
            });
            this.props.getUserPerms();
        }

        if (prevProps.app.loading.USER_FETCH_PERMS === true && this.props.app.loading.USER_FETCH_PERMS === false) {
            if (this.state.isSocialDeleted) {
                this.props.closeAllModals();
                this.setState({
                    isSocialDeleted: false,
                    isDeleting: 0
                });
            }
        }

    }

    _permErrorTest(obj) {

		for (let key in obj) {
			if (_.findKey(obj, 'perms') !== undefined) {
				return true;
			} else {
				if (_.isObject(obj[key])) {
					return this._permErrorTest(obj[key]);
				}
			}
		}

		return false;

	}

    render() {
        let constants = this.props.app.config.constants,
            displaySocials = [
                constants.POST_SVC_FACEBOOK,
                constants.POST_SVC_BLUESKY,
                constants.POST_SVC_THREADS,
                constants.POST_SVC_PINTEREST,
                constants.POST_SVC_LINKEDIN,
                constants.POST_SVC_GMYBUSINESS,
                constants.POST_SVC_TWITTER,
                constants.POST_SVC_INSTAGRAM_BUSINESS,
                constants.POST_SVC_TIKTOK,
                constants.POST_SVC_REDDIT,
                constants.POST_SVC_WORDPRESS,
                constants.POST_SVC_YOUTUBE,
                constants.POST_SVC_TUMBLR,
                constants.POST_SVC_BLOGGER,
                constants.POST_SVC_DISCORD,
                constants.POST_SVC_MASTODON,
                constants.POST_SVC_STOCKTWITS,
                constants.POST_SVC_SLACK,
            ],
            content = null,
            extraCopy = null,
            nextButton = null;

        if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
            displaySocials = [
                constants.POST_SVC_FACEBOOK,
                constants.POST_SVC_THREADS,
                constants.POST_SVC_PINTEREST,
                constants.POST_SVC_LINKEDIN,
                constants.POST_SVC_GMYBUSINESS,
                constants.POST_SVC_BLUESKY,
                constants.POST_SVC_INSTAGRAM_BUSINESS,
                constants.POST_SVC_TIKTOK,
                constants.POST_SVC_REDDIT,
                constants.POST_SVC_WORDPRESS,
                constants.POST_SVC_YOUTUBE,
                constants.POST_SVC_TUMBLR,
                constants.POST_SVC_BLOGGER,
                constants.POST_SVC_DISCORD,
                constants.POST_SVC_MASTODON,
                constants.POST_SVC_STOCKTWITS,
                constants.POST_SVC_SLACK,
                //constants.POST_SVC_TWITTER,
            ];
        }

        const generateSocialButton = (id) => {
            let index = ConstantMixin.getIconIndexByCode(id),
                name = ConstantMixin.getPostServiceNameByCode(id),
                Icon = IconFactory[index],
                social = null,
                loading = false,
                constants = this.props.app.config.constants;

            const socialClick = (e) => {
                let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

                if (onboarding) {
                    mixpanel.track("Social Onboarding - Connecting Social", {
                        'social': name
                    });

                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Social Onboarding Click',
                            event_data: {
                                social: name
                            }
                        });
                    }
                }

                if (id === constants.POST_SVC_MASTODON) {
                    this.props.addModal(
                        <SocialModal
                            {...this.props}
                            onboarding={onboarding}
                            activeTab="providehandle"
                            context="onboarding"/>
                    );
                } else if (id === constants.POST_SVC_BLUESKY) {
                    this.props.addModal(
                        <SocialModal
                            {...this.props}
                            onboarding={onboarding}
                            activeTab="blueskycreds"
                            context="onboarding"/>
                    );
                } else {
                    this.setState({
                        isConnecting: id
                    });
                    ConnectMixin.connectService.apply(this, [e]);
                }

            }

            if ((social = _.findWhere(this.props.socials.list, {psID: id})) !== undefined) {
                return displayConnectedSocial(social);
            }

            if (this.state.isConnecting === id || this.state.isDeleting === id) {
                loading = true;
            }

            if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
                if (id === constants.POST_SVC_TWITTER) {
                    return (
                        <div className="social-connector"
                                key={`onboarding-social-${id}`}
                                ref={this.twitterRef}
                                data-serviceid={id}
                                data-direct={true}
                                onClick={null}
                                role="button"
                                aria-label={`X (Twitter) is currently unavailable`}
                                onMouseOver={() => {
                                    this.setState({
                                        showTwitterWarning: true
                                    });
                                }}
                                onMouseOut={() => {
                                    this.setState({
                                        showTwitterWarning: false
                                    })
                                }}>
                            <Icon large={true} inactive={true} round={true} />
                            {(this.state.showTwitterWarning) ? (
                                <div className="twitter-warning">
                                    X (Twitter) is currently unavailable
                                </div>
                            ) : null}
                        </div>
                    );
                }
            }

            return (
                <div className="social-connector"
                        key={`onboarding-social-${id}`}
                        data-serviceid={id}
                        data-direct={true}
                        onClick={(!this.state.isConnecting && this.state.isDeleting === 0) ? socialClick : null}
                        title={name}
                        role="button"
                        aria-label={`add ${name}`}>
                    <Icon large={true} round={true} loading={loading}/>
                </div>
            );
        };

        const displayConnectedSocial = (social) => {
            return (
                <div key={`onboarding-social-${social.id}`} className="onboarding-avatar">
                    <SocialButton
                        {...this.props}
                        onboarding={true}
                        frozen={true}
                        connectAction={(e) => {
                            let modal = (
                                <ConfirmModal
                                    modalCopy="Would you like to remove this social?"
                                    showCancel={true}
                                    cancelLabel={"Do not remove"}
                                    cancelAction={() => {
                                        this.props.closeAllModals();
                                    }}
                                    confirmLabel="Remove"
                                    confirmAction={(e) => {

                                        this.setState({
                                            isDeleting: social.psID
                                        });
                                        setTimeout(() => {
                                            this.props.deleteSocial(social.id);
                                        }, 2000);
                                    }}/>
                            )
                            this.props.addModal(modal);
                        }}
                        social={social}/>
                </div>
            );
        };

        if (this.props.user.perms && this.props.user.perms.resources.outputsAvailable > 0) {
            let headline = "Connect your social media profiles";

            if (this.props.socials.list.length === 1) {
                headline = "Add another social or set up posting";
            }

            content = (
                <div>
                    <p className="top-copy">{headline}</p>
                    <Breakpoint desktop only>
                        <div className="social-container">
                            {displaySocials.slice(0, 5).map((id) => {
                                return generateSocialButton(id);
                            })}
                        </div>
                        <div className="social-container">
                            {displaySocials.slice(5, 10).map((id) => {
                                return generateSocialButton(id);
                            })}
                        </div>
                        <div className="social-container">
                            {displaySocials.slice(10, 15).map((id) => {
                                return generateSocialButton(id);
                            })}
                        </div>
                        <div className="social-container">
                            {displaySocials.slice(15).map((id) => {
                                return generateSocialButton(id);
                            })}
                        </div>
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <div className="social-container mobile">
                            {displaySocials.map((id) => {
                                return generateSocialButton(id);
                            })}
                        </div>
                    </Breakpoint>
                </div>
            );
        } else {
            content = (
                <div>
                    <p className="top-copy">Your first two social profiles are connected!</p>
                    <div className="social-container maxed">
                        {this.props.socials.list.map((social) => {
                            return displayConnectedSocial(social);
                        })}
                    </div>
                </div>
            );
        }

        if (this.props.socials.list.length > 0) {
            let buttonClass = "btn-primary reverse-fixed active set-up-button";

            extraCopy = (
                <div className="extra-copy">
                    <div className="copy-block">The <Link to="/account/subscription/compare">Basic Plan</Link> comes with three socials.</div>
                </div>
            );
            nextButton = (
                <Link to="/share/automate/new/inputs"
                    className={buttonClass}
                    onClick={(e) => {
                        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

                        if (onboarding) {
                            mixpanel.track("Social Onboarding - Advancing to Feed Creation");

                            if (this.props.recordEvent) {
                                this.props.recordEvent({
                                    pub_id: this.props.user.detail.id,
                                    event_name: 'Social Onboarding - Advance',
                                    event_data: {
                                        social: name
                                    }
                                });
                            }
                        }
                    }}>
                    Continue to Posting
                </Link>
            );
        }


        return (
            <Content contentClass="inline-modal" {...this.props}>
                <div className="onboarding-wrapper">
                    <h2>Let's Get You Set Up</h2>
                    {content}
                    {nextButton}
                    {extraCopy}
                </div>
            </Content>
        );
    }
}

OnboardingSocials.displayName = "OnboardingSocials";

OnboardingSocials.propTypes = {

};

OnboardingSocials.defaultProps = {

};

export default ComponentWithContext(OnboardingSocials);
